import React from 'react';
import StaticPage from '../../components/layouts/StaticPage';

function Imprint() {
  return (
    <StaticPage>
      <h1>Impressum</h1>
      <p>Triff wird betrieben von:</p>
      <p>
        Ganz digital GmbH
        <br />
        Bönirainstrasse 16
        <br />
        8080 Thalwil
        <br />
        <br />
        Telefon: <a href={'tel:+41445866870'}>+41 44 586 68 70</a>
        <br />
        E-Mail: <a href={'mailto: team@triff.app'}>team@triff.app</a>
        <br />
        Website:{' '}
        <a
          href="https://www.ganzdigital.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          www.ganzdigital.com
        </a>
        <br />
        <br />
        Geschäftsführung: Stefan Ganz
        <br />
        Firmennummer: CHE-413.648.491
        <br />
        <br />
        {`© 2016-${new Date().getFullYear()}, Ganz digital GmbH. Alle Rechte vorbehalten.`}
      </p>
    </StaticPage>
  );
}

export default Imprint;
